export default __webpack_public_path__ + "static/media/ReativarFalha.93f8458e.svg";